/*
 * @Author: Dom
 * @Date: 2022-06-04 17:46:34
 * @LastEditTime: 2022-06-05 00:49:45
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\views\logistics\erp\service.ts
 */
import request from "@/utils/request";
import {ErpParams} from './data.d'

export async function addErpManage(params:ErpParams) {
    return request({
        url: '/seller/v1/erpManage/addErpManage',
        method: 'POST',
        data: params
    })
}

export async function getErpManageList(params:ErpParams) {
    return request({
        url: '/seller/v1/erpManage/getErpManageList',
        method: 'POST',
        data: params
    })
}
